import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {useLayout} from '../../core'
import {useUser} from 'app/modules/auth/hooks'
import {useNavigate} from 'react-router-dom'
import {useAuth} from 'app/modules/auth/auth'
import {getLocalStorage} from 'app/utils'

const Toolbar1: FC = () => {
  const {classes} = useLayout()
  const navigate = useNavigate()

  const {data} = useUser(getLocalStorage('access_token'))
  const {isLoggedIn} = useAuth()
  let firstName = ''
  let lastName = ''
  if (isLoggedIn) {
    firstName = data?.data?.data?.firstName || ''
    lastName = data?.data?.data?.lastName || ''
  }

  return (
    <div className='toolbar' id='kt_toolbar'>
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
      >
        <div className='fs-6'>
          پنجره واحد خدمات دانشگاه امکانی جدید در راستای یکپارچه سازی تمامی خدمات در یک پنجره واحد
        </div>

        <div className='text-primary hoverable' onClick={() => navigate('/profile')}>
          {firstName + ' ' + lastName}
        </div>

        {/* {getLocalStorage('name')} خوش آمدید */}
        {/* <DefaultTitle /> */}
        {/* <div className='d-flex align-items-center py-1'>
          <div className='me-4'>
            <a
              href='#'
              className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG
                path='/media/icons/duotune/general/gen031.svg'
                className='svg-icon-5 svg-icon-gray-500 me-1'
              />
              Filter
            </a>
          </div>

          <a
            href='#'
            className='btn btn-sm btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_create_app'
            id='kt_toolbar_primary_button'
          >
            Create
          </a>
        </div> */}
      </div>
    </div>
  )
}

export {Toolbar1}
